export const PRO_PRICE = "$9";
export const TRIAL_DAYS = 7;
export const INTERVALS = {
  month: { price: "$9", per: "month", label: "Monthly", note: "" },
  year: { price: "$90", per: "year", label: "Yearly", note: "$7.50/mo · save 17%" },
};

export const PLANS = [
  {
    id: "free",
    name: "Acolyte",
    price: "$0",
    tagline: "For first rites",
    features: ["2 saved projects", "Record, upload & import songs", "Interval & in-key harmonies", "Full mixer with EQ, reverb & delay"],
  },
  {
    id: "pro",
    name: "High Priest · Pro",
    price: PRO_PRICE,
    tagline: "For the full choir",
    features: ["Unlimited projects", "AI Grimoire harmony suggestions", "WAV export (full mix & vocals only)", "Loop punch-in recording", "Everything in Acolyte"],
  },
];
